import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState: {
  documentTypes: {
    id: string;
    type: string;
    editable: boolean;
    order: number;
  }[];
  errorMessage: string;
  error: boolean;
  loading: boolean;
} = {
  documentTypes: [],
  error: false,
  loading: false,
  errorMessage: "",
};
const fetchDocumentTypes = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_DOCUMENT_TYPES_SUCCESS: {
      console.log("action.documentTypes", action.documentTypes);
      return updateObject(state, {
        documentTypes: action.documentTypes,
        error: false,
        loading: false,
        errorMessage: "",
      });
    }
    case actionTypes.FETCH_DOCUMENT_TYPES_STARTED:
      return updateObject(state, {
        documentTypes: initialState.documentTypes,
        error: false,
        loading: true,
        errorMessage: "",
      });

    case actionTypes.FETCH_DOCUMENT_TYPES_FAILED:
      return updateObject(state, {
        documentTypes: initialState.documentTypes,
        error: true,
        loading: false,
        errorMessage: action.errorMessage,
      });

    case actionTypes.RESET_DOCUMENT_TYPES:
      return updateObject(state, {
        documentTypes: initialState.documentTypes,
        error: false,
        loading: false,
        errorMessage: "",
      });

    default:
      return state;
  }
};

export default fetchDocumentTypes;
